import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch, withDefaults } from 'vue'
import { deliveryStore } from '@/stores/delivery'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryGeneralCheckRow',
  props: {
    label: null,
    currentValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['valueChanged'],
  setup(__props: any, { emit }) {

const props = __props as { label:string, currentValue:boolean, disabled:boolean };




const selectedValue = ref<boolean>(false)

onMounted(() => {
  selectedValue.value = props.currentValue
})

watch(() => props.currentValue, () => {
  selectedValue.value = props.currentValue
})

function valueChanged () : void {
  emit('valueChanged', selectedValue.value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 6},
        sm: {span: 6},
        md: {span: 6},
        lg: {span: 2}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_switch, {
            disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || props.disabled,
            checked: selectedValue.value,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
            onChange: valueChanged
          }, null, 8, ["disabled", "checked"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 18},
        sm: {span: 18},
        md: {span: 18},
        lg: {span: 22}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.label), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})